module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@3x-832b9d7fccafee7335d00f07efa16745.png";